<template>
    <div class="frame">
        <project-loader
            v-show="loading"
            :background-color="project.colors['text-secondary']"
            :color="project.colors['text-primary']"
        />
        <span v-for="media in project.medias" class="media" :key="media.id">
            <video
                v-if="media.project_media_id.media"
                ref="video"
                loop
                muted
                playsinline
                preload="metadata"
                @canplay="handleCanPlay(media.id)"
            >
                <source
                    :src="getUrl(media.project_media_id.media)"
                    type="video/mp4"
                />
            </video>
            <img v-else :src="getUrl(media.project_media_id.cover)" />
        </span>
    </div>
</template>

<script>
import getters from "@/mixins/getters.mixin";
import ProjectLoader from "@/components/ProjectLoader";

export default {
    mixins: [getters],
    components: { ProjectLoader },
    props: {
        project: {
            type: Object,
            required: true,
        },
    },
    computed: {
        videos() {
            return this.project.medias.filter(
                (media) => media.project_media_id.media !== null
            );
        },
        loading() {
            if (this.videos.length === 0) return false;
            return this.videos.every(
                (video) => this.$store.state.videosLoadMap[video.id] !== true
            );
        },
    },
    mounted() {
        // Fix Safari canplaythrough event firing
        if (this.$refs.video === undefined) return;
        for (let video of this.$refs.video) {
            if (video === undefined) continue;
            video.load();
        }
    },
    methods: {
        handleCanPlay(mediaId) {
            this.$store.commit("setMediaLoaded", mediaId);
        },
        play() {
            if (this.$refs.video === undefined) return;
            for (let video of this.$refs.video) {
                if (video === undefined) continue;
                video.play();
            }
        },
        pause() {
            if (this.$refs.video === undefined) return;
            for (let video of this.$refs.video) {
                if (video === undefined) continue;
                video.pause();
            }
        },
    },
};
</script>

<style scoped lang="sass">
@import ~include-media/dist/include-media
@import ~styles/base
@import ~styles/mixins
@import ~styles/typography

.frame
    position: relative
    z-index: 1
    display: flex
    gap: calc(var(--line-base) * .5)

    +media('>=large')
        flex: 0 0 66.667%
        margin: 0
        gap: var(--line-base)

.media
    flex-shrink: 1
    position: relative
    width: 116%
    border-radius: 5px
    overflow: hidden

    +media('>=large')
        box-shadow: 1em 1em 1.5em transparentize(black, .9)

    img, video
        display: block
        width: 100%

+media('>=large')
    .cover
        &:nth-child(odd)
            .frame
                transform: translateX(15.5%)

        &:nth-child(even)
            .frame
                transform: translateX(-15.5%)
</style>
